"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchAccountBadge = void 0;
const react_1 = __importDefault(require("react"));
const Icon_1 = require("../../../../Icon");
const UserTypeIcon_1 = require("../../../../UserTypeIcon");
require("./index.scss");
const className = 'account-badge';
const SearchAccountBadge = (props) => {
    const { name, onCloseClick, userType, disabled } = props;
    return (react_1.default.createElement("div", { className: className },
        userType && (react_1.default.createElement(UserTypeIcon_1.UserTypeIcon, { className: 'account-badge__type-icon', userType: userType })),
        react_1.default.createElement("span", { className: 'account-badge__name' }, name),
        !disabled && (react_1.default.createElement("button", { className: 'account-badge__close-button', type: 'button', onClick: onCloseClick },
            react_1.default.createElement(Icon_1.Icon, { name: 'x' })))));
};
exports.SearchAccountBadge = SearchAccountBadge;
//# sourceMappingURL=index.js.map